<template>
<li class="searchResults-item">
<!-- If Video, use modal component -->
    <modal v-if="item.urlType == 'Video'">
        <div slot="trigger" slot-scope="props" class="searchResults-item-inner">
            <a href="javascript:void(0)" @click="props.open" class="searchResults-item-inner-image playOverlay">
                <img v-if="!item.image" :src="'https://placehold.it/180x130?text=%20'" alt="" />
                <img v-else :src="item.image" :alt="item.imageAltText" :srcset="item.imageSrcSet" :sizes="item.imageSizes"/>
            </a>
            <div class="searchResults-item-inner-copy">
                <a href="javascript:void(0)" @click="props.open" class="link">
                    <h3 class="hdg hdg_3">{{item.name}}</h3>
                </a>
                <p>
                    {{item.summary}}
                </p>
            </div>
        </div>
        <template slot="modal-content">
            <div>
                <video-wrapper :src="item.url" :controls="true" controlsList="nodownload nofullscreen"></video-wrapper>
            </div>
        </template>
    </modal>
    <!-- else, use link -->
    <div v-else :href="item.url" class="searchResults-item-inner" :download="item.urlType == 'Download'">
        <a :href="item.download ? downloadUrl + encodeURIComponent(item.url) : item.url" class="searchResults-item-inner-image" :target="item.urlType == 'Download' ? '_blank' : '_self'">
            <img v-if="!item.image" :src="'https://placehold.it/180x130?text=%20'" alt="" />
            <img v-else :src="item.image" :alt="item.imageAltText" :srcset="item.imageSrcSet" :sizes="item.imageSizes"/>
        </a>
        <div class="searchResults-item-inner-copy">
            <a :href="item.url" class="link">
                <h3 class="hdg hdg_3">{{item.name}}</h3>
            </a>
            <p>{{item.summary}}</p>
        </div>
    </div>
</li>
</template>

<script>
import kohlerCorporateConfig from '../../kohlerCorporateConfig';
import Modal from "../Modal/Modal.vue";
import VideoWrapper from "../templates/VideoWrapper.vue";

export default {
    props: ['item'],
    components: {
        Modal,
        VideoWrapper
    },
    computed: {
        downloadUrl: () => kohlerCorporateConfig.downloadUrl,
    }
}
</script>

